var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1437252875"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.428711 11C0.428711 4.939 5.36771 0 11.4287 0C17.4897 0 22.4287 4.939 22.4287 11C22.4287 17.061 17.4897 22 11.4287 22C5.36771 22 0.428711 17.061 0.428711 11Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.1247 13.53C15.4437 13.849 15.4437 14.377 15.1247 14.696C14.9597 14.861 14.7507 14.938 14.5417 14.938C14.3327 14.938 14.1237 14.861 13.9587 14.696L11.4287 12.166L8.89871 14.696C8.73371 14.861 8.52471 14.938 8.31571 14.938C8.10671 14.938 7.89771 14.861 7.73271 14.696C7.41371 14.377 7.41371 13.849 7.73271 13.53L10.2627 11L7.73271 8.47C7.41371 8.151 7.41371 7.623 7.73271 7.304C8.05171 6.985 8.57971 6.985 8.89871 7.304L11.4287 9.834L13.9587 7.304C14.2777 6.985 14.8057 6.985 15.1247 7.304C15.4437 7.623 15.4437 8.151 15.1247 8.47L12.5947 11L15.1247 13.53Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.dea487f3d4248f68f17d3cb48b09abbe.svg";
export { ForwardRef as ReactComponent };